import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";

import { reducer as formReducer } from "redux-form";

import * as Stores from "./stores/reducers";
import * as Users from "./users/reducers";
import * as Products from "./products/reducers";
import * as Campaigns from "./campaigns/reducers";
import * as Segments from "./segments/reducers";
import * as Stocktaking from "./stocktaking/reducers";
import * as Discounts from "./discounts/reducers";
import * as AverageReceiptStatistics from "./statistics/averagereceipt/reducers";
import * as OnShelfAvailabilityStatistics from "./statistics/onshelfavailability/reducers";
import * as CampaignStatistics from "./statistics/campaign/reducers";
import * as CampaignProductsStatistics from "./statistics/campaignproducts/reducers";
import * as ProfitStatistics from "./statistics/profit/reducers";
import * as WasteStatistics from "./statistics/waste/reducers";
import * as UserStatistics from "./statistics/user/reducers";
import * as UserStoreStatistics from "./statistics/usersbystore/reducers";
import * as ProductWasteStatistics from "./statistics/productwaste/reducers";
import * as ProductProfitStatistics from "./statistics/productprofit/reducers";
import * as CustomerFeedbackStatistics from "./statistics/customerfeedback/reducers";
import * as UserLocation from "./userLocation/reducers";
import * as Tenants from "./tenants/reducers";
import * as DashboardDatedSalesStatistics from "./dashboard/sales/reducers";
import * as DashboardStoreEventsStatistics from "./dashboard/userevents/reducers";
import * as ToolbarNotifications from "./toolbarNotifications/reducer";
import * as Markets from "./markets/reducers";
import * as Languages from "./languages/reducers";
import * as PaymentProviders from "./paymentProvider/reducers";

import {
  createStateSyncMiddleware,
  initMessageListener
} from "redux-state-sync";

const rootReducer = combineReducers({
  stores: Stores.storesReducer,
  tenants: Tenants.tenantReducer,
  currentTenant: Tenants.currentTenantReducer,
  reloadTenant: Tenants.reloadTenantReducer,
  markets: Markets.marketsReducer,
  currentMarket: Markets.currentMarketReducer,
  loginMethods: Markets.loginMethodsReducer,

  storeInventoryItems: Stores.storeInventoryItemsReducer,
  allStoreInventoryItems: Stores.allStoreInventoryItemsReducer,
  storeDistributors: Stores.storeDistributorsReducer,

  storeOrders: Stores.storeOrdersReducer,
  awaitingStoreOrderProposals: Stores.awaitingStoreOrderProposalsReducer,

  storeClusterProducts: Products.storeClusterProductReducer,

  users: Users.userReducer,
  userOrders: Users.userOrdersReducer,
  userLocation: UserLocation.userLocationReducer,

  campaigns: Campaigns.reducer,
  segments: Segments.reducer,
  discounts: Discounts.reducer,
  averageReceiptStatistics: AverageReceiptStatistics.reducer,
  onShelfAvailabilityStatistics: OnShelfAvailabilityStatistics.reducer,
  campaignStatistics: CampaignStatistics.reducer,
  campaignProductsStatistics: CampaignProductsStatistics.reducer,
  profitStatistics: ProfitStatistics.reducer,
  wasteStatistics: WasteStatistics.reducer,
  productWasteStatistics: ProductWasteStatistics.reducer,
  productProfitStatistics: ProductProfitStatistics.reducer,
  userStatistics: UserStatistics.reducer,
  userStoreStatistics: UserStoreStatistics.reducer,
  customerFeedbackStatistics: CustomerFeedbackStatistics.reducer,

  awaitingStocktakingCounts: Stocktaking.awaitingStocktakingCountsReducer,
  awaitingStoreStocktakingItems:
    Stocktaking.awaitingStoreStocktakingItemsReducer,
  languages: Languages.languageReducer,
  paymentProviders: PaymentProviders.paymentProvidersReducer,

  dashboardDatedSalesStatistics: DashboardDatedSalesStatistics.reducer,
  userEventsStatistics: DashboardStoreEventsStatistics.reducer,
  toolbarNotifications: ToolbarNotifications.reducer,
  filteredStores: Stores.filteredStoresReducer,
  form: formReducer
});

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, createStateSyncMiddleware()))
);

export type AppState = ReturnType<typeof rootReducer>;

initMessageListener(store);

export default store;
